import { render } from "./selection_context_menu.vue?vue&type=template&id=87d36a96"
import script from "./selection_context_menu.vue?vue&type=script&lang=js"
export * from "./selection_context_menu.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/selection_context_menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87d36a96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87d36a96', __exports__)) {
    api.reload('87d36a96', __exports__)
  }
  
  module.hot.accept("./selection_context_menu.vue?vue&type=template&id=87d36a96", () => {
    api.rerender('87d36a96', render)
  })

}


export default __exports__